import React from 'react';
import { LanguageProvider } from './provider';
import RabContainer from './container/RabContainer';
const Rab = () => {
    return (<LanguageProvider>
      <RabContainer />
    </LanguageProvider>);
};
export default Rab;
